/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 *  @author    Afternet <info@afternet.gr>
 *  @copyright 2022 Afternet
 *  @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */
import React, {useEffect, useState} from 'react';
import {useTranslation} from "react-i18next";
import availableLanguages from "../Languages/availableLanguages";
import {useParams, useNavigate, useLocation } from "react-router-dom";

const useLang = () => {

    let params = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const { t, i18n } = useTranslation();

    const [lang, setLang] = useState({
        currentLang : i18n.language,
        switchLanguages: !!availableLanguages[i18n.options.extension] ? availableLanguages[i18n.options.extension].switchLanguages : 'en'
    });

    useEffect( ()=>{
        if( !availableLanguages[i18n.options.extension].supportedLanguages.includes(params.lang) ){
            //console.log('not available Language');
            i18n
                .changeLanguage(`${localStorage.getItem('autoRecLang') ? JSON.parse(localStorage.getItem('autoRecLang')) : availableLanguages[i18n.options.extension].default}`, () => {
                    navigate({
                        pathname: `/${localStorage.getItem('autoRecLang') ? JSON.parse(localStorage.getItem('autoRecLang')) : availableLanguages[i18n.options.extension].default}/`
                    });
                })
                .then(() => {
                    if(!localStorage.getItem('autoRecLang')){
                        localStorage.setItem('autoRecLang', JSON.stringify(availableLanguages[i18n.options.extension].default));
                    }

                    setLang({...lang, currentLang: `${localStorage.getItem('autoRecLang') ? JSON.parse(localStorage.getItem('autoRecLang')) : availableLanguages[i18n.options.extension].default}`});
                });

        }else{

            if( typeof params.lang == "undefined" || typeof i18n.language == "undefined"){ return; }
            if( params.lang == i18n.language){ return; }

            changeLanguage(params.lang);

        }
    }, [] )

    const changeLanguage = (code) => {

        const pathParts = location.pathname.split('/');
        pathParts[1] = code;
        let _url = pathParts.join('/');


        const queryParameters = new URLSearchParams(window.location.search);
        if(queryParameters.size !== 0){
            _url += "?";
            for(let value of queryParameters.keys()) {
                _url += `${value}=${queryParameters.get(value)}&`;
            }
        }

        i18n
            .changeLanguage(code, () => {
                navigate({
                    pathname: `${_url}`
                });
            }).then(() => {
                localStorage.setItem('autoRecLang', JSON.stringify(code));
                setLang({...lang, currentLang: code});
            });
    }

    return [lang, changeLanguage];

};

export default useLang;
